import React from "react";
import Link from "next/link";

const SimpleFooter = (props) => {
  return (
    <div className="w-full max-w-6xl px-12 mx-auto sticky top-[100vh]">
      <div className="flex flex-col md:flex-row md:justify-between pt-10 pb-10 text-center md:text-left">
        <dl
          className={`font-medium leading-tight md:no-underline mb-4 ${
            props.list_header || ""
          }`}
        >
          Company
          <dt className="mt-2 ts-heading-7">
            <Link
              href="/careers"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Careers
            </Link>
          </dt>
          <dt className="ts-heading-7">
            <Link
              href="https://www.teamshares.com/resources/"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Resources
            </Link>
          </dt>
          <dt className="ts-heading-7">
            <Link
              href="/privacy-policy"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Privacy policy
            </Link>
          </dt>
          <dt className="ts-heading-7">
            <Link
              href="/california-resident-privacy-notice"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              California resident privacy policy
            </Link>
          </dt>
          <dt className="ts-heading-7">
            <Link
              href="/california-personnel-privacy-notice"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              California personnel privacy policy
            </Link>
          </dt>
          <dt className="ts-heading-7">
            <Link
              href="/terms-and-conditions"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Terms of service
            </Link>
          </dt>
        </dl>
        <dl
          className={`font-medium leading-tight md:no-underline mb-4 no-hover ${
            props.list_header || ""
          }`}
        >
          Support
          <dt className="mt-2 mb-6 ts-heading-7">
            <a
              href={"mailto:hello@teamshares.com"}
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Email us
            </a>
          </dt>
        </dl>
        <dl
          className={`font-medium leading-tight md:no-underline mb-4 ${
            props.list_header || ""
          }`}
        >
          Looking for TeamsharesOS?
          <dt className="mt-2 ts-heading-7">
            <a
              href="https://os.teamshares.com"
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Log in here
            </a>
          </dt>
        </dl>
        <dl
          className={`font-medium leading-tight md:no-underline mb-4 ${
            props.list_header || ""
          }`}
        >
          Looking for leadership opportunities?
          <dt className="mt-2 ts-heading-7">
            <Link
              href={"/leadership"}
              className={`underline no-hover ${props.list_item || ""}`}
            >
              Learn more here
            </Link>
          </dt>
        </dl>
      </div>
    </div>
  );
};

export default SimpleFooter;
